import { render, staticRenderFns } from "./GetjobModal.vue?vue&type=template&id=0ecd800f&scoped=true"
import script from "./GetjobModal.vue?vue&type=script&lang=js"
export * from "./GetjobModal.vue?vue&type=script&lang=js"
import style0 from "./GetjobModal.vue?vue&type=style&index=0&id=0ecd800f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd800f",
  null
  
)

export default component.exports